import React from "react";
import PropTypes from "prop-types";
import {t} from "i18next";
import {getFormattedDate, getTimeFromNow, getUTCDate} from "utils/dateutils";

const Timestamp = ({incident_time, displayRelativeTime = false}) =>
  incident_time?.opened ? (
    <span
      data-testid={"Timestamp-Span"}
      title={getUTCDate(incident_time.opened)}>
      {displayRelativeTime
        ? ` ${getTimeFromNow(incident_time.opened)}`
        : t("incidentDetail.detail.incidentTime", {
            time: getFormattedDate(incident_time.opened)
          })}
    </span>
  ) : null;

Timestamp.propTypes = {
  /**
   * If true, date will be displayed in relative time from now
   *
   * @example "2 days ago"
   *
   * @defaultValue false
   */
  displayRelativeTime: PropTypes.bool,
  incident_time: PropTypes.shape({
    opened: PropTypes.string
  })
};
export default Timestamp;
